import { Injectable } from '@angular/core';
import { RecommendationModel, RecommendedProduct } from 'app/core/domain/recommendation.model';
import { RecommendationEntity, RecommendedProductEntity } from '../entities/recommendation.entity';

@Injectable({
  providedIn: 'root',
})
export class RecommendationMapper {
  mapFrom(entity: RecommendationEntity): RecommendationModel {
    return {
      id: entity.id,
      accountManagerName: entity.accountManagerName,
      createdAt: new Date(entity.createdAt),
      recommendedProducts: entity.recommendedProducts.map((product: RecommendedProductEntity) => ({
        id: product.productLegacyId,
        sku: product.sku,
        recommendedAsp: product.recommendedAsp,
        confirmationRate: product.confirmationRate,
        deliveryRate: product.deliveryRate,
        netDeliveryRate: product.netDeliveryRate,
        comment: product.comment,
        productImage: product.productImage,
        creativeLink: product.creativeLink,
        name: product.productName,
        originalPrice: product.originalPrice,
        isAddedToCatalog: product.isAddedToCatalog,
      })),
    };
  }

  mapTo(model: RecommendationModel): RecommendationEntity {
    return {
      id: model.id,
      accountManagerName: model.accountManagerName,
      createdAt: model.createdAt.toISOString(),
      recommendedProducts: model.recommendedProducts.map((product: RecommendedProduct) => ({
        productLegacyId: product.id,
        sku: product.sku,
        recommendedAsp: product.recommendedAsp,
        confirmationRate: product.confirmationRate,
        deliveryRate: product.deliveryRate,
        netDeliveryRate: product.netDeliveryRate,
        comment: product.comment,
        productImage: product.productImage,
        creativeLink: product.creativeLink,
        productName: product.name,
        originalPrice: product.originalPrice,
        isAddedToCatalog: product.isAddedToCatalog,
      })),
    };
  }
}
